import { fullBrowserVersion, isAndroid, isMobile, mobileVendor } from "react-device-detect";
import { v4 as uuidv4 } from "uuid";
import type { DeviceInfo } from "./types";
import { DEVICE_INFO_DEFAULTS } from "./types";
import { getSecureItem, setSecureItem } from "../storage/secureStorage";

const UUID_KEY = "device_uuid";

/**
 * Gets the device information including a unique identifier
 * @returns Promise<DeviceInfo> A promise that resolves to the device information
 */
export const getDeviceInfo = async (): Promise<DeviceInfo> => {
  try {
    const existingUuid = await getSecureItem(UUID_KEY);

    if (!existingUuid) {
      const newUuid = uuidv4();
      await setSecureItem(UUID_KEY, newUuid);

      return {
        ...DEVICE_INFO_DEFAULTS,
        brand: mobileVendor,
        is_tablet: isMobile,
        os_version: fullBrowserVersion,
        os: isAndroid ? "Android" : "iOS",
        device_brand: mobileVendor,
        unique_id: newUuid,
      };
    }

    return {
      ...DEVICE_INFO_DEFAULTS,
      brand: mobileVendor,
      is_tablet: isMobile,
      os_version: fullBrowserVersion,
      os: isAndroid ? "Android" : "iOS",
      device_brand: mobileVendor,
      unique_id: existingUuid,
    };
  } catch (error) {
    console.error("Error getting device info:", error);
    const fallbackUuid = uuidv4();
    return {
      ...DEVICE_INFO_DEFAULTS,
      unique_id: fallbackUuid,
    };
  }
};
